import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import { Button } from "@/components";

import Styles from "./ImageGrid.module.css";

/**
 * @typedef {import("@prismicio/client").Content.ImageGridSlice} ImageGridSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ImageGridSlice>} ImageGridProps
 * @param {ImageGridProps}
 */
const ImageGrid = ({ slice: { primary, items } }) => {
	return (
		<section className={Styles.wrapper}>
			<div className={Styles.contentContainer} data-contain="true">
				<div className={Styles.col}>
					<PrismicRichText field={primary?.heading} />
				</div>
				<div className={Styles.col}>
					<PrismicRichText field={primary?.description} />
					<Button link={primary?.cta_link} label={primary?.cta_label} />
				</div>
			</div>
			<div className={Styles.imageContainer}>
				{items.map((item, index) => (
					<PrismicNextImage
						key={index}
						field={item?.image}
						className={Styles.image}
					/>
				))}
			</div>
		</section>
	);
};

export default ImageGrid;
